// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_lm7","cls2":"ResearchInterestSearchResults-cls2_LMk ResearchInterestSearchResults-cls1_lm7"};